import React, { useContext, useMemo, useRef } from 'react';
import { RightDrawerView, RightDrawerViewProps } from './RightDrawer.view';
import { idGenerator } from '../../helpers/idGenerator';
import { ModalsContext } from '../../providers/ModalsProvider';
import { useDidMount } from '../../hooks/useDidMount';
import { AppContext } from '../../providers/AppProvider';

export type RightDrawerControllerProps = Omit<
  RightDrawerViewProps,
  'title' | 'onCloseAttempt' | 'onClose' | 'setCloseConfirmed' | 'toggleRightDrawer' | ''
> & {
  // extend your RightDrawerViewProps
};

export const RightDrawerController = (props: RightDrawerControllerProps): JSX.Element => {
  const { toggleRightDrawer } = useContext(AppContext);
  const modalId = useMemo(() => idGenerator('modal'), []);
  const [modalsRef, modalsUpdater] = useContext(ModalsContext);
  const ref = useRef<HTMLDivElement>(null);
  const onClose = () => {
    toggleRightDrawer(null);
  };
  const onCloseAttempt = () => {
    const lastModalRef = modalsRef.current[modalsRef.current.length - 1];
    if (lastModalRef.id === modalId) {
      onClose();
    }
  };

  useDidMount(() => {
    if (modalId && !modalsRef.current.filter(item => item.id === modalId).length) {
      modalsUpdater({ type: 'add', value: modalId })(modalsRef);
    }
    return () => {
      modalsUpdater({ type: 'remove', value: modalId })(modalsRef);
    };
  });

  const viewProps: RightDrawerViewProps = {
    ...props,
    onCloseAttempt,
    onClose
  };

  return <RightDrawerView {...viewProps} ref={ref} />;
};
